import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { ORGANIZATION_ANALYTICS_PATH, PREFIX } from '@app/constants';

export const OrganizationsPageHeader = () => {
  const navigate = useNavigate();

  const navigateToOrganizationAnalytics = () => {
    navigate(ORGANIZATION_ANALYTICS_PATH);
  };

  return (
    <div className={`${PREFIX}organizations-page-header`}>
      <Button type="primary" onClick={navigateToOrganizationAnalytics}>
        Аналитика
      </Button>
    </div>
  );
};
